// extracted by mini-css-extract-plugin
export default {"container":"OO-z","modal":"PO-z","dimensions":"QO-z","brandName":"RO-z","productName":"SO-z","recipientEmail":"TO-z","recommendedFit":"UO-z","hiddenField":"VO-z"};